import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import './styles.scss';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const navigateTo = (url: string) => {
    toggleDrawer();
    navigate(url);
  };

  return (
    <div className='w-full flex'>
      <div className='w-full h-24 flex  font-bold items-center'>
        <div className='grow pl-12 sm:hidden block'>
          <div onClick={toggleDrawer}>
            <FontAwesomeIcon icon={faBars} size='1x' />
          </div>
        </div>
        <div className='grow pl-12 sm:block hidden'>
          <Link to={ROUTES.HOME}>Home</Link>
        </div>
        <Link className='pr-12 sm:block hidden' to={ROUTES.SKILLS}>
          Skills
        </Link>
        <Link className='pr-12 sm:block hidden' to={ROUTES.PROJECTS}>
          Projects
        </Link>
        <Link className='pr-12 sm:block hidden' to={ROUTES.EDUCATION}>
          Education
        </Link>
        <Link className='pr-12 sm:block hidden' to={ROUTES.CONTACTME}>
          Contact Me
        </Link>
      </div>
      {isOpen && (
        <div className='drawer flex grow sm:hidden block'>
          <div className='h-full w-72 bg-black pl-4 pt-12 drawer-container'>
            <div
              className='p-2 mb-2 text-2xl cursor-pointer'
              onClick={() => navigateTo(ROUTES.HOME)}
            >
              Home
            </div>
            <div
              className='p-2 mb-2 text-2xl cursor-pointer'
              onClick={() => navigateTo(ROUTES.SKILLS)}
            >
              Skills
            </div>
            <div
              className='p-2 mb-2 text-2xl cursor-pointer'
              onClick={() => navigateTo(ROUTES.PROJECTS)}
            >
              Projects
            </div>
            <div
              className='p-2 mb-2 text-2xl cursor-pointer'
              onClick={() => navigateTo(ROUTES.EDUCATION)}
            >
              Education
            </div>
            <div
              className='p-2 mb-2 text-2xl cursor-pointer'
              onClick={() => navigateTo(ROUTES.CONTACTME)}
            >
              Contact Me
            </div>
          </div>
          <div className='grow bg-red' onClick={toggleDrawer}></div>
        </div>
      )}
    </div>
  );
};
export default NavBar;
